import classNames from "classnames";

import { FC, Fragment } from "react";
import useI18n from "../../../hooks/useTranslations";
import { SteelVersionForSettings } from "../../../http/vertigrip/types/vertigripSettings";
import { getMinutesRoundedTimestamp } from "../../../utils";
import ImageBorderBox from "../../ui/BorderBox";
import ModalDialog from "../../ui/ModalDialog";
import styles from "./SteelVersionsHelpModal.module.css";

type SteelVersionsHelpModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect?: (item: SteelVersionForSettings) => void;
  items: SteelVersionForSettings[];
};

export const SteelVersionsHelpModal: FC<SteelVersionsHelpModalProps> = ({
  items,
  isOpen,
  onClose,
  onSelect,
}: SteelVersionsHelpModalProps) => {
  const i18n = useI18n();

  return (
    <>
      {isOpen && (
        <ModalDialog
          title={i18n.translation.steelVersions.plural}
          onClose={onClose}
          isSubmitting={false}
          actions={[{ title: i18n.translation.common.close, onClick: onClose }]}
        >
          <div
            className={classNames(styles.grid, {
              [styles.grid1]: items.length === 1,
              [styles.grid2]: items.length > 1,
            })}
          >
            {items.map((item) => (
              <Fragment key={item.id}>
                <ImageBorderBox
                  onClick={onSelect ? () => onSelect(item) : undefined}
                  showIsMissing={true}
                  title={item.name}
                  description={item.description}
                >
                  <div className={styles.img}>
                    {item.image ? (
                      <ImageBorderBox.Image
                        src={`${import.meta.env.VITE_BUCKET_URL}${item.image}?${getMinutesRoundedTimestamp()}`}
                      />
                    ) : (
                      ImageBorderBox.PlaceHolder
                    )}
                  </div>
                </ImageBorderBox>
              </Fragment>
            ))}
          </div>
        </ModalDialog>
      )}
    </>
  );
};
